var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.shipment &&
      _vm.shipment.labels &&
      _vm.shipment.labels.find((e) => e.airBillNumber || e.packageNumber)
        ? _c("ShippingLabelNew", {
            key:
              (_vm.shipment.labels && JSON.stringify(_vm.shipment.labels)) || 1,
            attrs: { shipment: _vm.shipment, purchaseOrder: _vm.purchaseOrder },
          })
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "card",
          staticStyle: {
            "overflow-y": "auto",
            "max-height": "400px",
            "min-height": "30px",
          },
        },
        [
          !_vm.rates || !_vm.rates.length
            ? _c("div", { staticClass: "card-body text-light" }, [
                _vm._v("No rates loaded"),
              ])
            : _c(
                "table",
                {
                  key: JSON.stringify(_vm.shipment.labels),
                  staticClass: "w-100 table table-striped table-fluid",
                },
                [
                  _vm._m(0),
                  _c(
                    "tbody",
                    _vm._l(_vm.rates, function (rate) {
                      return _c("tr", [
                        _c("td", {}, [
                          _c("div", { staticClass: "d-flex" }, [
                            _c("img", {
                              staticClass: "mr-2",
                              staticStyle: { "max-height": "24px" },
                              attrs: { src: `/img/${rate.carrierCode}.png` },
                            }),
                          ]),
                          _c("div", { staticClass: "small" }, [
                            _vm._v(_vm._s(rate.serviceName)),
                          ]),
                        ]),
                        _c("td", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("currency")(
                                  (rate.shippingCost || rate.price) / 100,
                                  _vm.distributorCurrencySign
                                )
                              ) +
                              "\n            "
                          ),
                          rate.usedCategoryShipping
                            ? _c("i", {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true },
                                  },
                                ],
                                staticClass: "far fa-exclamation-triangle ml-1",
                                attrs: {
                                  title: `This rate was use product category shippingPackages`,
                                },
                              })
                            : _vm._e(),
                        ]),
                        _c("td", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm._f("currency")(
                                  rate.price / 100,
                                  _vm.distributorCurrencySign
                                )
                              )
                            ),
                          ]),
                        ]),
                        _c("td", [
                          _c("div", {}, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-center justify-content-start",
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary btn-sm mr-2",
                                    on: {
                                      click: function ($event) {
                                        return _vm.chooseRate(rate)
                                      },
                                    },
                                  },
                                  [_vm._v("Select")]
                                ),
                                _vm.canAddLabel
                                  ? _c("ShippingLabelNew", {
                                      attrs: {
                                        rate: rate,
                                        purchaseOrder: _vm.purchaseOrder,
                                        fobPointId: _vm.fobPointId,
                                        productId: _vm.productId,
                                        shipment: _vm.shipment,
                                        supplierCode: _vm.supplierCode,
                                      },
                                      on: {
                                        onSave: (e) => _vm.$emit("onSave", e),
                                      },
                                    })
                                  : _vm._e(),
                                rate.error
                                  ? _c("div", { staticClass: "ml-3" }, [
                                      _c("i", {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            modifiers: { hover: true },
                                          },
                                        ],
                                        staticClass:
                                          "fas fa-exclamation-circle text-danger",
                                        attrs: {
                                          title: _vm._f("rateErrorMessage")(
                                            rate
                                          ),
                                        },
                                      }),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ])
                    }),
                    0
                  ),
                ]
              ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Method")]),
        _c("th", [_vm._v("Cost")]),
        _c("th", [_vm._v("Price")]),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }